import {
  Component,
  Inject,
  Input,
  NgZone,
  OnInit,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from '@angular/forms';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { SingleSelectComponent } from '../single-select/single-select.component';

@Component({
  selector: 'single-select-dialog',
  templateUrl: './single-select-dialog.component.html',
  styleUrls: ['./single-select-dialog.component.css'],
})
export class SingleSelectDialogComponent implements OnInit, AfterViewInit {
  form!: FormGroup;

  formControl!: FormControl;

  options: any[] = [];

  @ViewChild('singleSelectComponent')
  singleSelectComponent!: SingleSelectComponent;

  constructor(
    public dialog: MatDialog,
    public fb: FormBuilder,
    public matDialogRef: MatDialogRef<SingleSelectDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public zone: NgZone
  ) {
    if (this.data.number) {
      for (var i = 0; i < this.data.number; i++) {
        this.options.push({ number: i + 1 });
      }
    } else {
      this.options = this.data.options;
    }
  }

  ngOnInit() {
    let initialValue;

    if (this.data.number) {
      initialValue = this.options[0];
    }

    if (this.data.initialValue) {
      initialValue = this.data.initialValue;
    }

    this.formControl = new FormControl(
      {
        value: initialValue,
        disabled: false,
      },
      Validators.required
    );

    this.form = this.fb.group({
      number: this.formControl,
    });
  }

  ngAfterViewInit() {
    // Auto-focus the search input when the dialog opens and search is enabled
    if (this.data?.showSearch && this.singleSelectComponent) {
      setTimeout(() => {
        // Use the proper MatSelect API to open the dropdown
        if (this.singleSelectComponent.matSelect) {
          this.singleSelectComponent.matSelect.open();

          // After the dropdown opens, focus the search input
          setTimeout(() => {
            const searchInput = document.querySelector(
              '.search-input'
            ) as HTMLInputElement;
            if (searchInput) {
              searchInput.focus();
            }
          }, 100);
        }
      }, 100);
    }
  }

  changed(): void {}

  primaryTapped(): void {
    if (this.form.invalid) {
      return;
    }

    this.save();
  }

  save(): void {
    this.matDialogRef.close(this.formControl.value);
  }
}
